import { Component, OnInit } from '@angular/core';
import { FeatureFlagsService } from '../../system-services/FeatureFlags.service';
import { ModuleAccessService } from '../../system-services/ModuleAccess/ModuleAccess.service';
import { TranslationService } from '../../translations';

@Component({
    selector: 'pi-copyright-footer',
    template: `
        <div>
            © The Predictive Index {{ getCopyrights() }}
            <span style="display: none">{{ flagsEnabled }}</span>
            <span style="display: none">{{ moduleAccess.configString }} </span>
        </div>
    `,
    standalone: false
})
export class PIFooterComponent implements OnInit {
    flagsEnabled: string;

    constructor(
        public featureFlags: FeatureFlagsService,
        public moduleAccess: ModuleAccessService,
        public TR: TranslationService
    ) {}

    ngOnInit() {
        this.flagsEnabled = this.featureFlags.featureFlagValues();
    }

    getCopyrights() {
        return new Date().getFullYear();
    }
}
